import { render, staticRenderFns } from "./accountsGroup.vue?vue&type=template&id=81891c18&scoped=true&"
import script from "./accountsGroup.vue?vue&type=script&lang=js&"
export * from "./accountsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81891c18",
  null
  
)

export default component.exports